module.exports = __webpack_public_path__ + "static/media/keerthana.ef183238.jpg";